<template>
  <div>
    <div v-if="isCareMember" class="planTruelife">
      <h2>Truelife.org Membership Pricing</h2>
      <a-table :columns="columnsTruelife" :data-source="planTrueLife" size="middle" bordered rowKey="key">
        <template slot="priceMonth" slot-scope="text"> <b>$</b>{{ text }} </template>
        <template slot="priceYear" slot-scope="text"> <b>$</b>{{ text }} </template>
        <div slot="action" slot-scope="record" class="action">
          <a href="javascript:;" @click="onSelect(record)">Choose Plan</a>
        </div>
      </a-table>
    </div>
    <div v-else-if="isTruelifeMember" class="planTruelifeCare">
      <h2>TruelifeCare.org Membership Pricing</h2>
      <a-table :columns="columnsTruelife" :data-source="planTrueLifeCare" size="middle" bordered rowKey="key">
        <template slot="priceMonth" slot-scope="text"> <b>$</b>{{ text }} </template>
        <template slot="priceYear" slot-scope="text"> <b>$</b>{{ text }} </template>
        <div slot="action" slot-scope="record" class="action">
          <a href="javascript:;" @click="onSelect(record)">Choose Plan</a>
        </div>
      </a-table>
    </div>

    <a-row :gutter="20" v-if="!isEmpty(planSelected)">
      <a-col :span="isDesktop ? 12 : 24">
        <a-card title="Membership Details" class="style3 videoPlayer">
          <a-form :form="form" :layout="'vertical'" id="checkoutInfo">
            <p class="font-weight-bold" style="font-size: 24px;">Average Attendance: {{ planSelected.member }}</p>
            <a-form-item label="Select Monthly or Yearly Payments">
              <a-radio-group v-model="planMonth" button-style="solid" size="large">
                <a-radio-button :value="true"> Monthly ${{ planSelected.priceMonth }} </a-radio-button>
                <a-radio-button :value="false"> Yearly ${{ planSelected.priceYear }}</a-radio-button>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="Coupon code">
              <a-input-search placeholder="input coupon code" enter-button="Check" size="large" @search="onSearch" />
              <template v-if="!isEmpty(couponMessage)">
                <a-tag :color="isErrorCoupon ? 'red' : 'green'" class="mt-2">{{ couponMessage }}</a-tag>
              </template>
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 12, offset: 0 }">
              <a-button class="mt-5" type="primary" @click="handleSubmit" :loading="isLoading">Signup</a-button>
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { includes, isEmpty, get } from 'lodash';
import initRecurly from '@/services/Recurly';
import PlanService from '@/services/PlanService';
import UserService from '@/services/UserService';
export default {
  data: () => ({
    planTrueLife: [
      {
        priceYear: '329.00',
        cardsnumber: 1000,
        planYear: '329year',
        priceMonth: '32.00',
        planMonth: '32monthly',
        key: '0_49',
        member: '0 - 49',
      },
      {
        priceYear: '399.00',
        cardsnumber: 1000,
        planYear: '249year',
        priceMonth: '39.00',
        planMonth: '39monthly',
        key: '50_99',
        member: '50 - 99',
      },
      {
        priceYear: '529.00',
        cardsnumber: 2500,
        planYear: '529yearly',
        priceMonth: '52.00',
        planMonth: '52monthly',
        key: '100_149',
        member: '100 - 149',
      },
      {
        priceYear: '659.00',
        cardsnumber: 5000,
        planYear: '659yearly',
        priceMonth: '65.00',
        planMonth: '65monthly',
        key: '150_399',
        member: '150 - 399',
      },
      {
        priceYear: '899.00',
        cardsnumber: 10000,
        planYear: '899yearlyplan',
        priceMonth: '89.00',
        planMonth: '89monthly',
        key: '400_749',
        member: '400 - 749',
      },
      {
        priceYear: '1,299.00',
        cardsnumber: 20000,
        planYear: '2999year',
        priceMonth: 129.0,
        planMonth: '129monthly',
        key: '750_1499',
        member: '750 - 1,499',
      },
      {
        priceYear: '1,599.00',
        cardsnumber: 30000,
        planYear: '4499year',
        priceMonth: '159.00',
        planMonth: '159monthly',
        key: '1500_2500',
        member: '1,500 - 2,500',
      },
    ],
    planTrueLifeCare: [
      {
        key: '0_49',
        member: '0 - 49',
        priceMonth: '29.99',
        priceYear: '299.00',
        planMonth: '49monthlycounseling',
        planYear: '49yearlycounseling',
      },
      {
        key: '50_99',
        member: '50 - 99',
        priceMonth: '39.99',
        priceYear: '399.00',
        planMonth: '99monthlycounseling',
        planYear: '99yearlycounseling',
      },
      {
        key: '100_199',
        member: '100 - 199',
        priceMonth: '65.99',
        priceYear: '659.00',
        planMonth: '199monthlycounseling',
        planYear: '199yearlycounseling',
      },
      {
        key: '200_349',
        member: '200 - 349',
        priceMonth: '85.99',
        priceYear: '859.00',
        planMonth: '349monthlycounseling',
        planYear: '449yearlycounseling',
      },
      {
        key: '350_499',
        member: '350 - 499',
        priceMonth: '115.99',
        priceYear: '1159.00',
        planMonth: '499monthlycounseling',
        planYear: '499yearlycounseling',
      },
      {
        key: '500_749',
        member: '500 - 749',
        priceMonth: '149.99',
        priceYear: '1499.00',
        planMonth: '749monthlycounseling',
        planYear: '749yearlycounseling',
      },
      {
        key: '750_999',
        member: '750 - 999',
        priceMonth: '199.99',
        priceYear: '1999.00',
        planMonth: '999monthlycounseling',
        planYear: '999yearlycounseling',
      },
      {
        key: '1000_1499',
        member: '1,000 - 1,499',
        priceMonth: '235.99',
        priceYear: '2359.00',
        planMonth: '1499monthlycounseling',
        planYear: '1499yearlycounseling',
      },
      {
        key: '1500_1999',
        member: '1,500 - 1,999',
        priceMonth: '265.99',
        priceYear: '2659.00',
        planMonth: '1999monthlycounseling',
        planYear: '1999yearlycounseling',
      },
      {
        key: '2000_2499',
        member: '2,000 - 2,499',
        priceMonth: '299.99',
        priceYear: '2999.00',
        planMonth: '2499monthlycounseling',
        planYear: '2499yearlycounseling',
      },
    ],
    planSelected: {},
    planMonth: false,
    isErrorCoupon: false,
    couponMessage: '',
    isLoading: false,
    couponCode: '',
  }),
  computed: {
    ...mapState(['settings', 'user']),
    isTruelifeMember() {
      return includes(this.user.user.role, 'evangelism');
    },
    isCareMember() {
      return includes(this.user.user.role, 'care');
    },
    isWebSite() {
      return includes(this.user.user.role, 'website');
    },
    columnsTruelife() {
      return [
        {
          title: 'Average Attendance',
          key: 'member',
          dataIndex: 'member',
          width: 150,
        },
        {
          title: 'Yearly Price',
          key: 'priceYear',
          dataIndex: 'priceYear',
          scopedSlots: {
            customRender: 'priceYear',
          },
        },
        {
          title: '12 Payments',
          key: 'priceMonth',
          dataIndex: 'priceMonth',
          scopedSlots: {
            customRender: 'priceMonth',
          },
        },
        {
          title: 'Choose',
          key: 'operation',
          width: 100,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ];
    },
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  async beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'checkout' });
    await initRecurly();
  },
  mounted() {
    if ((this.isCareMember && this.isTruelifeMember) || this.isWebSite) {
      this.$router.push({ name: 'dashboard' });
    }
  },
  methods: {
    isEmpty,
    onSelect(record) {
      this.planSelected = record;
    },
    async onSearch(value) {
      this.couponMessage = '';
      try {
        const { planMonth, planYear } = this.planSelected;
        const resp = await recurly
          .Pricing()
          .plan(this.planMonth ? planMonth : planYear)
          .coupon(value);
        if (!isEmpty(resp)) {
          console.log(resp);
          this.couponMessage = 'Coupon code valid';
          this.isErrorCoupon = false;
          this.couponCode = value;
        } else {
          this.couponCode = '';
          throw Error('Coupon invalid');
        }
      } catch (error) {
        this.couponMessage = 'Coupon code invalid';
        this.isErrorCoupon = true;
        console.log({ error });
        this.couponCode = '';
      }
    },
    async handleSubmit() {
      try {
        this.isLoading = true;
        const userInfo = await UserService.doGetUserInfo();
        const dataSubmit = {
          plan: this.planMonth ? this.planSelected.planMonth : this.planSelected.planYear,
          recurly_code: userInfo.recurly_code,
          signature: userInfo.signature,
        };
        if (!isEmpty(this.couponCode)) {
          dataSubmit['coupon_code'] = this.couponCode;
        }
        const resp = await PlanService.doAddSubcription(dataSubmit);
        console.log({ resp });
        this.$notification['success']({
          message: 'Add subcription successful.',
        });
        // console.log(resp);
      } catch (error) {
        console.log({ error });
        this.$notification['error']({
          message: error.response.status,
          description: get(error, 'response.data.error', error.message),
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .ant-table {
  background: #fff;
}
.ant-table-row-cell-break-word {
  padding: 15px;
}
</style>
